import React from 'react';
import { Route, Switch } from 'react-router-dom';
import RoutePages from 'src/routes/routes';

import GoogleTagManager from 'src/components/2.2.0/common/GoogleTagManager';
import Navigation from 'src/components/2.2.0/layout/Navigation';

import useDevelopmentMode from 'src/hooks/2.2.0/useDevelopmentMode';
import PrivateRoute from 'src/routes/PrivateRoute';
import PublicRoute from 'src/routes/PublicRoute';

const RouteApp = () => {
  const isDevMode = useDevelopmentMode();
  return (
    <>
      <Navigation />
      {!isDevMode && <GoogleTagManager />}

      <Switch>
        {RoutePages.private.map(route => (
          <PrivateRoute
            key={route.path}
            path={route.path}
            exact
            component={props => (
              <route.Layout>
                <route.Page {...props} />
              </route.Layout>
            )}
          />
        ))}
        {RoutePages.public.map(route => (
          <PublicRoute
            key={route.path}
            path={route.path}
            exact
            component={props => (
              <route.Layout>
                <route.Page {...props} />
              </route.Layout>
            )}
          />
        ))}
        {RoutePages.normal.map(route => (
          <Route
            key={route.path}
            path={route.path}
            exact
            component={props => (
              <route.Layout>
                <route.Page {...props} />
              </route.Layout>
            )}
          />
        ))}
      </Switch>
    </>
  );
};

export default RouteApp;
